export enum ProfileScreens {
  PROFILE_SCREEN = "profileScreen",
}
